// src/config/edgeFunctions.ts
// Edge function toggle configuration
// Set to false to disable an edge function, true to enable it
// After changing values, redeploy the application

export type SearchType = 'vehicleNumber' | 'metroCard' | 'metefyToken' | 'username';

export const edgeFunctions: Record<SearchType, {
  // Rate limiting pre-check before searches
  secureSearch: boolean;
  
  // Password validation and protected profile data retrieval
  protectedProfileData: boolean;
  
  // IP-based location enrichment for search logs
  getLocation: boolean;
}> = {
  vehicleNumber: {
    secureSearch: true,
    protectedProfileData: true,
    getLocation: true,
  },
  metroCard: {
    secureSearch: true,
    protectedProfileData: true,
    getLocation: true,
  },
  metefyToken: {
    secureSearch: false,
    protectedProfileData: true,
    getLocation: true,
  },
  username: {
    secureSearch: true,
    protectedProfileData: false,
    getLocation: true,
  },
} as const;

